let inputFilter = function(){
    window.scrollTo(0,0)
    // document.getElementsByClassName('scroll-content')[0].scrollTo(0,0);
}

export default inputFilter;
